import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 6a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0V5l2-4h14l2 4v1z",
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm0 6H4v-4a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v4zm-3.281 4H7.281c.357-.702.536-1.434.627-2h4.184c.091.566.27 1.298.627 2zM12 6c0 1.103-.897 2-2 2s-2-.897-2-2h4zM2 6h4c0 1.103-.897 2-2 2s-2-.897-2-2zm1.618-4h12.764l1 2H2.618l1-2zm16.277 2.553l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4A1.002 1.002 0 0 0 0 5v1c0 1.474.811 2.75 2 3.444V15a1 1 0 0 0 1 1h2.871c-.157.747-.508 1.7-1.318 2.105a1.002 1.002 0 0 0-.527 1.125c.108.451.51.77.974.77h10c.464 0 .866-.319.974-.77a1.002 1.002 0 0 0-.527-1.125c-.801-.4-1.153-1.356-1.313-2.105H17a1 1 0 0 0 1-1V9.444c1.189-.694 2-1.97 2-3.444V5c0-.155-.036-.309-.105-.447z"
});

var SvgOnlineStoreMajorTwotone = function SvgOnlineStoreMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgOnlineStoreMajorTwotone as S };
